import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('IncomingPrepaymentService', IncomingPrepaymentService);

  IncomingPrepaymentService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
  ];

  function IncomingPrepaymentService(
    RestResource,
    CONFIG,
    $translate,
    $filter,
    UtilService,
    SessionService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrlPrepayment = environment.apiEndpoint + 'incoming_prepayments';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getPrepayments: getPrepayments,
      saveIncomingPrepayment: saveIncomingPrepayment,
      deleteIncomingPrepayment: deleteIncomingPrepayment,
      getReceivedPaymentDocumentsPrepayment: getReceivedPaymentDocumentsPrepayment,
    };

    return service;

    ///////////////

    function getFilterCriteria() {
      var filter = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'consecutive',
      };

      return filter;
    }

    function getPrepayments(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrlPrepayment,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
              stats: response.meta.stats,
            };
          } else {
            return {
              items: response,
            };
          }
        },
        function () {
          return {
            items: [],
            totalItems: 0,
            entryLimit: 0,
            totalPages: 0,
            stats: [],
          };
        }
      );
    }

    function saveIncomingPrepayment(incomingPrepayment, type = 'request') {
      var url = apiUrlPrepayment;
      var method = 'post';

      if (incomingPrepayment.id) {
        // edit
        url += '/' + incomingPrepayment.id;
        method = 'put';
      }

      var lang = CONFIG.DEFAULT_CONTENT_LANGUAGE;

      function success(response) {
        if (type === 'request') {
          var msg = !incomingPrepayment.id
            ? 'INCOMING_PREPAYMENT_MODIFIED'
            : 'INCOMING_PREPAYMENT_CREATED';
          utils._successMsg($translate(msg));
        }

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }
      return RestResource.request(
        method,
        url,
        { incoming_prepayment: incomingPrepayment, lang: lang },
        success,
        failure
      );
    }

    function deleteIncomingPrepayment(incomingPrepayment, successCallback) {
      let params = {
        title: 'DELETE_INCOMING_PREPAYMENT',
        itemName: incomingPrepayment.incoming_consecutive,
        reason: 'DELETE_ITEM_REASON',
        successMsg: 'DELETED_INCOMING_PREPAYMENT',
        company_id: incomingPrepayment.company_id,
      };

      let url = apiUrlPrepayment + '/' + incomingPrepayment.id;
      utils.deleteItem(url, successCallback, params);
    }

    function getReceivedPaymentDocumentsPrepayment(id, params) {
      if (!params) {
        params = {};
      }

      return RestResource.request(
        'get',
        apiUrlPrepayment + '/' + id + '/get_received_payment_documents',
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }
  }
})();
